import { render, staticRenderFns } from "./QuestionTemplate.vue?vue&type=template&id=09bda7d9&scoped=true"
import script from "./QuestionTemplate.vue?vue&type=script&lang=js"
export * from "./QuestionTemplate.vue?vue&type=script&lang=js"
import style0 from "./QuestionTemplate.vue?vue&type=style&index=0&id=09bda7d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bda7d9",
  null
  
)

export default component.exports